import Analytics from '@getaccept/lib-shared-new/src/analytics';
import bugsnagClient from '@getaccept/lib-shared-new/src/bugsnag';
import { AnalyticsEvent, AnalyticsUserTrait } from '@getaccept/lib-shared-new/src/types/analytics';
import { LocalStorageHelper } from '@getaccept/lib-shared-new/src/helpers/local-storage.helper';
import { LocalStorageKey } from '@getaccept/lib-shared-new/src/enums/local-storage';
import VerifyUserService from '../../services/verify-user.service';
import type { ErrorMessage } from '../../types/error-message';
import { SignupErrorKey } from '../types/enums/signup-error-key';
import type { ProfileInformation } from '../types/profile-information';

export class VerifyUserHelper {
  static async verifyUser(profileInformation: ProfileInformation, id: string, key: string) {
    try {
      if (id) {
        Analytics.identify(id, {
          [AnalyticsUserTrait.FirstName]: profileInformation.firstName,
          [AnalyticsUserTrait.LastName]: profileInformation.lastName,
          [AnalyticsUserTrait.Language]: profileInformation.language,
          [AnalyticsUserTrait.Mobile]: profileInformation.phoneNumber,
        });
      } else {
        Analytics.identify(undefined, {
          [AnalyticsUserTrait.FirstName]: profileInformation.firstName,
          [AnalyticsUserTrait.LastName]: profileInformation.lastName,
          [AnalyticsUserTrait.Language]: profileInformation.language,
          [AnalyticsUserTrait.Mobile]: profileInformation.phoneNumber,
        });
      }

      return await VerifyUserService.verify({
        profileInformation,
        id,
        key,
      });
    } catch (e) {
      if (bugsnagClient) {
        bugsnagClient.notify(e);
      }
      throw this.getErrorMessage(e);
    }
  }

  static getErrorMessage(error: Error) {
    switch (error.message) {
      case SignupErrorKey.InvalidId:
        return {
          title: 'something-went-wrong',
          description: 'please-verify-that-your-link-is-valid',
        };
      case SignupErrorKey.NoResponseUrl:
      default:
        return {
          title: 'something-went-wrong',
          description: 'please-try-again-or-contact-support_v2',
        };
    }
  }
  static trackUserInfo(profileInformation: ProfileInformation, id: string) {
    if (id) {
      Analytics.identify(id, {
        [AnalyticsUserTrait.FirstName]: profileInformation.firstName,
        [AnalyticsUserTrait.LastName]: profileInformation.lastName,
        [AnalyticsUserTrait.Language]: profileInformation.language,
        [AnalyticsUserTrait.Mobile]: profileInformation.phoneNumber,
      });
    } else {
      Analytics.identify(undefined, {
        [AnalyticsUserTrait.FirstName]: profileInformation.firstName,
        [AnalyticsUserTrait.LastName]: profileInformation.lastName,
        [AnalyticsUserTrait.Language]: profileInformation.language,
        [AnalyticsUserTrait.Mobile]: profileInformation.phoneNumber,
      });
    }
  }

  static trackPageLoaded(id: string) {
    const localData = JSON.parse(
      LocalStorageHelper.getLocalStorage(LocalStorageKey.SignupAnalyticsData)
    );
    if (id) {
      Analytics.identify(id, {
        ...localData,
        [AnalyticsUserTrait.SignupStep]: 2,
      });
      LocalStorageHelper.reset(LocalStorageKey.SignupAnalyticsData);
    } else {
      Analytics.identify(undefined, {
        ...localData,
        [AnalyticsUserTrait.SignupStep]: 2,
      });
    }
    Analytics.track(AnalyticsEvent.SignupLoadedStep2, {
      [AnalyticsUserTrait.SignupStep]: 2,
    });
  }

  static trackVerifyUserError(errorMessage: ErrorMessage) {
    Analytics.track(AnalyticsEvent.SignupFailed, {
      [AnalyticsUserTrait.SignupStep]: 2,
      errorMessage: errorMessage.title,
    });
    Analytics.identify(undefined, {
      [AnalyticsUserTrait.SignupStep]: 2,
    });
  }
}
